import { useSessionStorage } from '@mantine/hooks';

// A session-storage hook to store the value of 'fbl-browser-extension-login' in session storage
type TabId = number;

/**
 * Preserves the tabId of the browser extension login page
 * This is used to refresh the browser extension page post login so that user is not confused with the login state
 */

function useBrowserExtensionLoginParams() {
  const [value, setValue, removeValue] = useSessionStorage<TabId>({
    key: 'fbl-browser-extension-login',
  });

  return { value, setValue, removeValue };
}

export { useBrowserExtensionLoginParams };
